<div class="d-flex flex-row p-2" *ngIf="place">
  <i
    *ngIf="place?.Address"
    class="modus-icons mr-2 mt-1"
    style="font-size: large"
    tooltip="{{ place.IsShared ? 'Shared Location' : 'Private Location' }}"
    container="body"
    [adaptivePosition]="false"
  >
    <img
      *ngIf="!place?.IsShared"
      src="../assets/img/icons/star.svg"
      class="d-flex"
      width="18px"
      height="18px"
    />
    <img
      *ngIf="place?.IsShared"
      src="../assets/img/icons/star_locked.svg"
      class="d-flex"
      width="18px"
      height="18px"
    />
  </i>
  <div class="d-flex flex-column flex-grow-1 text-truncate">
    <div class="d-flex flex-row justify-content-between text-truncate">
      <div>
        <span class="font-weight-bold small text-truncate">{{
          place?.PlaceName
        }}</span>
      </div>
    </div>
    <span
      *ngIf="place?.Address"
      class="{{
        place?.PlaceName
          ? 'font-weight-normal small text-truncate'
          : 'font-weight-bold small text-truncate'
      }}"
    >
      <span *ngIf="place?.FullAddress">{{ place?.FullAddress }}</span>
    </span>
    <span *ngIf="place?.Address?.County" class="text-gray-4 small text-truncate"
      >{{ place?.Address?.County }} County</span
    >
  </div>
</div>
